"use strict";

exports.__esModule = true;
exports.AuditLogContext = void 0;
var _Utils = require("../../../Utils");
var _AuditLogController = require("./AuditLogController");
/**
 * Provides an audit log context to consumers
 */
var AuditLogContext = exports.AuditLogContext = (0, _Utils.createEnhancedContext)({
  propName: "auditLogs",
  defaultController: _AuditLogController.AuditLogController
});